import React, { useEffect, useRef, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import {
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Progress,
  Select,
  Table,
} from "antd";
import svg27 from "../../../assets/svg/svg27.svg";
import svg12 from "../../../assets/svg/svg12.svg";
import svg48 from "../../../assets/svg/svg48.svg";
import svg49 from "../../../assets/svg/svg49.svg";
import svg29 from "../../../assets/svg/svg29.svg";
import BreadCrumb from "../../../layout/BreadCrumb";
import CardLoading from "../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { cashConverter, extractYear, formatText } from "../../../utils";
import { setActiveObj } from "../../../features/obj/objSlice";
import moment from "moment";
import ConfirmModal from "../../../components/ConfirmModal";
import { save } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";

function EvaluationTable() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const url = "evaluation/fetch_evaluations";
  const urlProjects = "main_project/fetch_mainprojects";
  const { loading, data, count, dataProjects } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[urlProjects] || [],
    count: state.fetch.count[urlProjects] || 0,
    dataProjects: state.fetch.data[urlProjects] || [],
  }));

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const [projectId, setProjectId] = useState(null);
  const [yearData, setYearData] = useState(null);

  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: urlProjects,
        evaName: e.target.value == "" ? null : e.target.value,
        evaProjectId: projectId ? projectId : null,
        projectEvaluation: "projectReports",
        year: extractYear(yearData),
      })
    );
  };

  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "evaluation", data: prodd }));
    await navigate("/rob/evaluation-add");
  };
  const handleDisable = () => {};
  const handleAdd = async () => {
    await dispatch(setActiveObj({ key: "evaluation", data: {} }));
    await navigate("/rob/evaluation-add");
  };
  const handleView = async () => {
    await dispatch(setActiveObj({ key: "evaluation", data: prodd }));
    await navigate("/rob/evaluation-details");
  };
  const handleViewName = async (item) => {
    await dispatch(setActiveObj({ key: "evaluation", data: item }));
    await navigate("/rob/evaluation-details");
  };

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "evaluation/delete_evaluation",
        evaId: prodd?.evaId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const settingItems = [
    // {
    //   key: "1",
    //   label: (
    //     <div onClick={handleEdit}>
    //       <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
    //         <img src={svg12} alt="svg12" />{" "}
    //         <span className="whitespace-nowrap">Edit</span>
    //       </Link>
    //       <div className="mt-[1rem]">
    //         <Divider />
    //       </div>
    //     </div>
    //   ),
    // },
    {
      key: "2",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg48} alt="svg48" />{" "}
            <span className="whitespace-nowrap">Project Details</span>
          </Link>
        </div>
      ),
    },
    // {
    //   key: "3",
    //   label: (
    //     <div onClick={handleOpenDelete}>
    //       <Link className="flex items-center gap-x-2 actions-text my-2">
    //         <img src={svg49} alt="svg49" className="w-4 h-4" />
    //         <span className="whitespace-nowrap">Delete</span>
    //       </Link>
    //       <div className="mt-[1rem]">
    //         <Divider />
    //       </div>
    //     </div>
    //   ),
    // },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Project Name",
      width: "300px",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.projectName}
          </div>
        );
      },
      sorter: (a, b) => a.projectName.localeCompare(b.projectName),
    },

    {
      title: "Type",
      dataIndex: "projectTypeName",
      sorter: (a, b) => a.projectTypeName.localeCompare(b.projectTypeName),
    },
    {
      title: "Contractor",
      dataIndex: "projectContractor",
      sorter: (a, b) => a.projectContractor.localeCompare(b.projectContractor),
    },
    {
      title: "Implementing Agency",
      dataIndex: "projectAgencyName",
      sorter: (a, b) => a.projectAgencyName.localeCompare(b.projectAgencyName),
    },
    {
      title: "Associated Scheme",
      dataIndex: "projectSchemeAssociatedName",
      sorter: (a, b) =>
        a.projectSchemeAssociatedName.localeCompare(
          b.projectSchemeAssociatedName
        ),
    },
    {
      title: "County",
      dataIndex: "projectCountyName",
      sorter: (a, b) => a.projectCountyName.localeCompare(b.projectCountyName),
    },

    {
      title: "Project Cost",
      dataIndex: "projectCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.projectCost.localeCompare(b.projectCost),
    },
    {
      title: "Total Disbursment to Date(Kes.)",
      dataIndex: "projectTotalDisbursement",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) =>
        a.projectTotalDisbursement.localeCompare(b.projectTotalDisbursement),
    },
    {
      title: "Start Date",
      dataIndex: "projectStartDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.projectStartDate).valueOf() -
        moment(b.projectStartDate).valueOf(),
    },
    {
      title: "Progress",
      dataIndex: "projectCompletionRate",
      render: (item) => {
        return <div>{<Progress percent={item} />}</div>;
      },
      sorter: (a, b) =>
        a.projectCompletionRate.localeCompare(b.projectCompletionRate),
    },
    {
      title: "Status",
      dataIndex: "projectStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          PLANNED: "#3250FF",
          STALLED: "#F44336",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: urlProjects,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        evaProjectId: projectId ? projectId : null,
        projectEvaluation: "projectReports",
        year: extractYear(yearData),
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, [projectId, yearData]);

  const onFinish = () => {};

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <BreadCrumb breadcrumbs={[{ title: "Projects in Evaluation" }]} />
      <div className="flex flex-col w-full lg:px-[1.25rem] flex-1  white_card mt-[1.25rem]">
        <div className="flex lg:flex-row flex-col  lg:items-center justify-between gap-y-4">
          <div className="form-add-h">Projects in Evaluation</div>
          <div className="w-[250px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <img src={svg29} alt="svg29" />{" "}
              <span className="ml-1">Add a New Evaluation</span>
            </button>
          </div>
        </div>

        <div className="flex items-center mt-[2.03rem] w-full gap-x-[1.25rem]">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className="w-full  "
            form={form}
          >
            <div className="w-full flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
              <span className="">Select Project</span>
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  dataProjects?.length > 0 &&
                  dataProjects?.map((item) => ({
                    value: item?.projectId,
                    label: item?.projectName,
                  }))
                }
                value={projectId}
                onChange={(value) => setProjectId(value)}
                placeholder="Select"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
              />
              <DatePicker
                placeholder="Year"
                className="input !w-[31.1rem]"
                picker="year"
                value={yearData}
                onChange={(value) => setYearData(value)}
              />
            </div>
          </Form>

          <div className="lg:w-[29.1875rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search..."}
            />
          </div>
        </div>

        <Table
          rowSelection={false}
          className="mt-[1.31rem] w-full"
          scroll={{
            x: "max-content",
          }}
          rowKey={(record) => record?.evaId}
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchTableData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
        />
      </div>

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </div>
  );
}

export default EvaluationTable;
